import _flow from 'lodash/flow'
import _sortBy from 'lodash/sortBy'
import { createFilterOption } from 'frontend/helpers/filterSelectorUtils'
import { listStandardAbilityCertifications } from 'frontend/communications/standards'
import { StandardAbilityCertification } from 'frontend/communications/dto/StandardAbilityCertification'

const stateObj = {
  standardAbilityCertifications: [],
}

const getters = {
  areStandardAbilityCertificationsActive (state) {
    return state.standardAbilityCertifications.some(level => level.enabled)
  },
  getSelectorStandardAbilityCertificationOptions: state => (including=[]) => {
    return _flow([
      () => state.standardAbilityCertifications.filter(certification => including.includes(certification.id) || certification.enabled),
      items => items.map(certification => {
        const newCertification = new StandardAbilityCertification({
          id: certification.id,
          acronym: certification.acronym,
          description: certification.description,
        })
        return createFilterOption({
          text: newCertification.compoundName,
          value: newCertification.id,
          checked: false,
          chip: newCertification.acronym,
        })
      }),
      items => _sortBy(items, 'text'),
    ])()
  },
  getAssignableStandardAbilityCertifications: (state, rootGetters) => including => {
    return rootGetters.getSelectorStandardAbilityCertificationOptions(including).map(certificationOption => {
      const certification = rootGetters.getStandardAbilityCertificationsById(certificationOption.value)
      return {
        ...certificationOption,
        isDisabled: certification.allowedCertifiers.length > 0 && !certification.allowedCertifiers.includes(rootGetters.userId),
      }
    })
  },
  getStandardAbilityCertifications (state) {
    return _sortBy(state.standardAbilityCertifications.filter(c => c.enabled), 'acronym')
  },
  getStandardAbilityCertificationsById: (state) => (id) => {
    return state.standardAbilityCertifications.find(certification => certification.id === id)
  },
}

const mutations = {
  setStandardAbilityCertifications (state, certifications) {
    state.standardAbilityCertifications = certifications
  },
}

const actions = {
  fetchStandardAbilityCertifications ({ commit }) {
    return listStandardAbilityCertifications().then(certifications => {
      commit('setStandardAbilityCertifications', certifications)
      return certifications
    })
  },
}

export default {
  getters,
  mutations,
  state: stateObj,
  actions,
}
